var BASWebServiceClass = (function () {
    function BASWebServiceClass() {
    }
    return BASWebServiceClass;
}());
//# sourceMappingURL=BASWebServiceClass.js.map